
import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import './piechart.css';

const PieChart = ({ data, showTotalLabel, chartType }) => {
  const chartRef = useRef(null);
  const tooltipRef = useRef(null);
  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');

    const hasData = data.datasets && data.datasets[0].data.some((value) => value > 0);
    const displayData = hasData
      ? data
      : {
        labels: ['No Data'],
        datasets: [
          {
            data: [100],
            backgroundColor: ['#d3d3d3'],
            hoverBackgroundColor: ['#d3d3d3'],
          },
        ],
      };

    const chart = new Chart(ctx, {
      type: 'pie',
      data: displayData,
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            external: function (context) {
              let tooltipEl = tooltipRef.current;

              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip';
                tooltipEl.className = 'custom-tooltip';
                tooltipEl.innerHTML = '<div></div>';
                document.body.appendChild(tooltipEl);
                tooltipRef.current = tooltipEl;
              }

              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0 || context.tooltip.dataPoints.length === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              if (tooltipModel.body) {
                let innerHtml = '<div class="tooltip-content">';

                if (chartType === 'candidatecount') {
                  const color = '#000522';
                  const value = '<strong>' + tooltipModel.dataPoints[0].formattedValue + '</strong>';

                  innerHtml += `<div class="tooltip-line" style="display: flex; align-items: center;  background-color: ${color}; color: #fff;width:160px; height: 20px;">`;
                  innerHtml += `<span class="chartjs-tooltip-key" style="background:${tooltipModel.labelColors[0].backgroundColor}; width: 10px; height: 10px; display: inline-block;"></span>`;
                  innerHtml += `<span>${tooltipModel.dataPoints[0].label}: ${value}</span>`;
                  innerHtml += `</div>`;
                } else {
                  const bodyLines = tooltipModel.body.map((bodyItem) => bodyItem.lines);

                  bodyLines.forEach((body, i) => {
                    const color = tooltipModel.labelColors[i].backgroundColor;
                    const value = '<strong>' + body[0] + '</strong>%';
                    innerHtml += `<div class="tooltip-line" style="display: flex; align-items: center; ">`;
                    innerHtml += `<span class="chartjs-tooltip-key" style="background:${color}; width: 10px; height: 10px; display: inline-block;"></span>`;
                    innerHtml += `<span>${value}</span>`;
                    innerHtml += `</div>`;
                  });

                  innerHtml += '<div class="tooltip-label">';
                  innerHtml += `<span>${tooltipModel.dataPoints[0].label}</span>`;
                  innerHtml += '</div>';
                }

                innerHtml += '</div>';

                tooltipEl.innerHTML = innerHtml;
              }

              const position = context.chart.canvas.getBoundingClientRect();

              tooltipEl.style.opacity = 1;
              tooltipEl.style.position = 'absolute';
              tooltipEl.style.backgroundColor = chartType === 'candidatecount' ? '#000522' : '#ffffff';
              tooltipEl.style.color = chartType === 'candidatecount' ? '#ffffff' : '#000522';
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
              tooltipEl.style.fontFamily = tooltipModel.options.bodyFont.family;
              tooltipEl.style.fontSize = tooltipModel.options.bodyFont.size + 'px';
              tooltipEl.style.fontStyle = tooltipModel.options.bodyFont.style;
              tooltipEl.style.padding = tooltipModel.options.padding + 'px ' + tooltipModel.options.padding + 'px';
              tooltipEl.style.pointerEvents = 'none';
            },
          },
        },
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
      },
    });

    return () => {
      chart.destroy();
      if (tooltipRef.current) {
        document.body.removeChild(tooltipRef.current);
        tooltipRef.current = null;
      }
    };
  }, [data, chartType]);

  const hasData = data.datasets && data.datasets[0].data.some((value) => value > 0);
  const displayData = hasData
    ? data
    : {
      labels: ['No Data'],
      datasets: [
        {
          data: [100],
          backgroundColor: ['#d3d3d3'],
          hoverBackgroundColor: ['#d3d3d3'],
        },
      ],
    };

  return (
    <div className="piechart-wrapper">
      <div className={`piechart-container ${!hasData ? 'no-data' : ''}`}>
        <canvas ref={chartRef} />
        {hasData && (
          <div className="custom-legend">
            {displayData.labels.map((label, index) => (
              <div key={index} className="legend-item">
                <span
                  className="legend-color"
                  style={{ backgroundColor: displayData.datasets[0].backgroundColor[index] }}
                ></span>
                {showTotalLabel ? `${displayData.datasets[0].data[index]} : ${label}` : label}
              </div>
            ))}
            {showTotalLabel && (
              <div className="legend-item total-profiles-item">
                {displayData.datasets[0].data.reduce((acc, value) => acc + value, 0)} | Total Profiles
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PieChart;